import { setXavisExperiments } from './debug';

export namespace $storage {
    export let is_available = false;
    let can_persist = false;

    try {
        sessionStorage.setItem('_y_storage_test', '42');
        sessionStorage.removeItem('_y_storage_test');
        is_available = true;
        localStorage.setItem('_y_storage_test', '42');
        localStorage.removeItem('_y_storage_test');
        can_persist = true;

        if(localStorage.getItem('xavis_experiments'))
            setXavisExperiments(true);
    } catch(e) {}

    export function putString(key: string, value?: string, persist?: boolean) {
        if(!is_available) return;
        if(value == undefined) {
            sessionStorage.removeItem(key);
            can_persist && localStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value);
            if(persist && can_persist)
                localStorage.setItem(key, value);
        }
    }

    export function putObject(key: string, obj: any, persist?: boolean) {
        putString(key, obj == undefined ? undefined : JSON.stringify(obj), persist);
    }

    export function getString(key: string, remove?: boolean) {
        if(!is_available) return undefined;
        let value = sessionStorage.getItem(key);
        if(value == null) {
            if(can_persist) {
                value = localStorage.getItem(key);
                if(value != null) {
                    if(remove)
                        localStorage.removeItem(key);
                    return value;
                }
            }
        } else {
            if(remove) {
                sessionStorage.removeItem(key);
                can_persist && localStorage.removeItem(key);
            }
            return value;
        }
        return undefined;
    }

    export function getObject(key: string, remove?: boolean) {
        const value = getString(key, remove);
        return value != undefined ? JSON.parse(value) : undefined;
    }

    export function remove(key: string) {
        if(!is_available) return;
        sessionStorage.removeItem(key);
        can_persist && localStorage.removeItem(key);
    }
}
